import { splitEvery } from "ramda";

import { nonHolidays, sortHolidays } from "utils/holidaysUtils";

export const getHolidaysDays = (dateSelected) => {
  const sortedHolidays = sortHolidays(dateSelected);
  const midpoint = Math.ceil(sortedHolidays.length / 2);
  return splitEvery(midpoint, sortedHolidays);
};

export const getCelebratesDays = () => {
  const celebrate = ["Birthdays", "Anniversary", "Weddings", "Graduation", "Baby"];
  const celebrateColumn = nonHolidays.filter(({ name }) => celebrate.includes(name));
  return celebrateColumn;
};

export const getGreetingsDays = () => {
  const greetings = ["Love", "Thanks", "You Rock", "Get well", "Congrats", "Sorry", "Free"];
  const greetingsColumn = nonHolidays.filter(({ name }) => greetings.includes(name));
  return greetingsColumn;
};
